// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3_lNpMK","categoryTitle":"_1hVpqlz","header__active":"_12D2pIB","container":"_2ZP8TKg","imageWrapper":"_3SPkusY","textWrapper":"_3FyxBKb"};